import { render, staticRenderFns } from "./labelTableNew.vue?vue&type=template&id=54fbf5a4&"
import script from "./labelTableNew.vue?vue&type=script&lang=js&"
export * from "./labelTableNew.vue?vue&type=script&lang=js&"
import style0 from "./labelTableNew.vue?vue&type=style&index=0&id=54fbf5a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports